<template>
  <div v-if="template" class="flex flex-col h-full -m-10">
    <div class="flex flex-col bg-white border-b border-slate-300 shrink-0">
      <div class="px-5 pt-5 h-full">
        <h1 class="text-xl font-bold pb-3">
          <input
            v-model="template.name"
            class="w-full border border-slate-300 bg-transparent focus:ring-0 text-xl font-bold hover:bg-slate-50 focus:bg-slate-50 px-4 rounded"
            type="text"
            placeholder="Template Name"
          />
        </h1>
        <div class="grow mb-5">
          <textarea
            v-model="template.description"
            class="w-full border border-slate-300 bg-transparent focus:ring-0 resize-none hover:bg-slate-50 focus:bg-slate-50 px-4 py-2 rounded"
            rows="2"
            placeholder="Description"
          ></textarea>
        </div>
      </div>
      <div class="flex flex-row">
        <router-link :to="{ name: 'edit-template' }" class="border border-b-0 border-l-0 px-5 py-2">Template</router-link>
        <router-link :to="{ name: 'edit-variables' }" class="border border-b-0 border-l-0 px-5 py-2">Variables</router-link>
        <router-link :to="{ name: 'edit-questions' }" class="border border-b-0 border-l-0 px-5 py-2">Questions</router-link>
        <router-link :to="{ name: 'edit-steps' }" class="border border-b-0 border-l-0 px-5 py-2">Steps</router-link>
      </div>
    </div>
    <div class="flex-1">
      <router-view v-slot="{ Component }">
        <keep-alive>
          <component :is="Component"></component>
        </keep-alive>
      </router-view>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useAdminStore } from '../../admin/adminStore'
import { storeToRefs } from 'pinia'
const props = defineProps<{ templateID: string }>()

const adminStore = useAdminStore()
await adminStore.load(props.templateID)
const { template } = storeToRefs(adminStore)
</script>

<style scoped>
.router-link-active {
  @apply bg-slate-200;
}
</style>
